@if (gridOptions) {
  <dv-grid [actions]="actions()">
    <ag-grid-angular
      dvGridInSidesheet
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </dv-grid>
}
